
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/mvp-app-development-company",
      function () {
        return require("private-next-pages/mvp-app-development-company.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/mvp-app-development-company"])
      });
    }
  